<template>
  <b-form-input ref="binput" v-mask="mask" v-bind="$attrs" :value="value" />
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'BootstrapCustomInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    mask: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  mounted() {
    const listeners = { ...this.$listeners };
    const input = this.$refs.binput.$refs.input;

    const logEventDecorator = (fn, eventName, isFocused) => (event) => {
      if (eventName === 'input' && !isFocused()) {
        return;
      }

      // if (!['mousemove', 'mouseleave'].includes(eventName)) {
      //   console.log(eventName, event);
      // }
      return fn(event);
    };

    if (input) {
      for (const eventName in listeners) {
        const decoratedListener = logEventDecorator(
          listeners[eventName],
          eventName,
          () => this.isFocused,
        );
        input.addEventListener(eventName, decoratedListener);
      }

      input.addEventListener('focusin', () => (this.isFocused = true));
      input.addEventListener('focusout', () => (this.isFocused = false));
    }
  },
  beforeDestroy() {
    const listeners = { ...this.$listeners };
    const input = this.$refs.binput.$refs.input;
    if (input) {
      for (const eventName in listeners) {
        input.removeEventListener(eventName, listeners[eventName]);
      }
    }
  },
};
</script>
